import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SeoService {
  constructor(
    private meta: Meta, 
    private title: Title
  ) {}

  setDefaultTags() {
    const title = 'PawPrint AI — виртуальный ветеринар для вашего питомца 24/7';
    const description = 'PawPrint — AI-ассистент для владельцев домашних животных. Задайте вопрос о здоровье, питании и уходе за питомцем и получите мгновенный совет. Консультация ветеринара онлайн — кошки, собаки, кролики и другие питомцы.';
    const keywords = 'ветеринар онлайн, AI ветеринар, вопросы о питомцах, здоровье кошки, здоровье собаки, уход за питомцем, PawPrint, AI чат питомец, pawprint.kz';
    const url = 'https://pawprint.kz/';
    const siteName = 'PawPrint AI — виртуальный ветеринар';

    this.title.setTitle(title);

    const tags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { name: 'robots', content: 'index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large' },
      { rel: 'canonical', href: url },
      { property: 'og:locale', content: 'ru_RU' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { property: 'og:site_name', content: siteName },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ];

    tags.forEach(tag => {
      // try to update existing tag, otherwise add
      try {
        if ((tag as any).name) {
          this.meta.updateTag({ name: (tag as any).name, content: (tag as any).content });
        } else if ((tag as any).property) {
          this.meta.updateTag({ property: (tag as any).property, content: (tag as any).content });
        }
      } catch (e) {
        // fallback to addTag
        this.meta.addTag(tag as any);
      }
    });

    // Ensure canonical link
    try {
      let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
    } catch (e) {
      // ignore DOM issues
    }

    // Add JSON-LD structured data similar to index.html
    try {
      const ldId = 'site-jsonld';
      let script = document.getElementById(ldId) as HTMLScriptElement | null;
      const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        'url': url,
        'name': siteName,
        'inLanguage': 'ru-RU',
        'description': description,
        'potentialAction': {
          '@type': 'SearchAction',
          'target': 'https://pawprint.kz/?q={search_term_string}',
          'query-input': 'required name=search_term_string'
        }
      };

      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = ldId;
        script.className = 'rank-math-schema-pro';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } catch (e) {
      // ignore
    }
  }

  /**
   * Set custom tags for a page. Any provided field overrides the defaults.
   * Example: { title, description, url, image }
   */
  setTags(tags: { title?: string; description?: string; keywords?: string; url?: string; image?: string; siteName?: string }) {
    const defaults = {
      title: 'PawPrint AI — виртуальный ветеринар для вашего питомца 24/7',
      description: 'PawPrint — AI-ассистент для владельцев домашних животных. Задайте вопрос о здоровье, питании и уходе за питомцем и получите мгновенный совет.',
      keywords: 'ветеринар онлайн, AI ветеринар, вопросы о питомцах, здоровье кошки, здоровье собаки, уход за питомцем, PawPrint, pawprint.kz',
      url: 'https://pawprint.kz/',
      siteName: 'PawPrint AI — виртуальный ветеринар',
    };

    const title = tags.title || defaults.title;
    const description = tags.description || defaults.description;
    const keywords = tags.keywords || defaults.keywords;
    const url = tags.url || defaults.url;
    const siteName = tags.siteName || defaults.siteName;

    this.title.setTitle(title);

    // Update basic tags
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:site_name', content: siteName });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });

    // canonical
    try {
      let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
    } catch (e) {}

    // open graph image
    if (tags.image) {
      this.meta.updateTag({ property: 'og:image', content: tags.image });
      this.meta.updateTag({ name: 'twitter:image', content: tags.image });
    }
  }
}
